module.exports = __webpack_public_path__ + "img/30_2006_bp.e1a7416d.jpg";